<template>
    <div>
      <div ref="contentElement"></div>
    </div>
  </template>
    
  <script setup>
  import { text2html } from '@utils/utils';
  
  const props = defineProps({
    item_data: {
      type: Object,
      required: true,
    },
  });
  
  const contentElement = ref(null);
  
  /*
    content: "#W#G可炼化#W#r#W耐久度：180/181     品相：#cFFFFFF崭新  "
  */
  
  onMounted(async () => {
    text2html(props.item_data['content'], contentElement.value);
  });
  </script>

    